// src/components/Can.js
import { usePermissions } from "../context/PermissionContext";

export default function Can({ permission, children }) {
  const permissions = usePermissions();
  return permissions.includes(permission) ? children : null;
}
